<template>
  <div class="input-wrapper">

    <label
      for="postalCode"
      class="input-wrapper__label"
    >{{ ($t('companyFormData.postalCode')) }} *</label>

      <input
        id="postalCode"
        name="postalCode"
        autocomplete="off"
        required
        type="text"
        maxlength="20"
        placeholder="52076"
        class="input-wrapper__input"
        :class="{ 'invalid-input': errorObj.postalCode }"
        :value="postalCode"
        @input="(e) => {debouncedInputValidate($emit('update:modelValue', e.target.value)); postalCode=e.target.value}"
        @blur="validateOnBlur"
        @keydown.tab="handleTabKey"
      />

      <div
          v-if="errorObj.postalCode"
          class="input-wrapper__label input-wrapper__label--error">
          {{ $t(errorObj.postalCode) }}
      </div>

  </div>
</template>

<script>
import { ref } from 'vue'
import useSignup from '@/composables/useSignup'
import { useI18n } from 'vue-i18n'
import { debounce } from 'lodash'
import useTabKeyValidation from '@/composables/useTabKeyValidation'

export default {
  setup () {
    const { t } = useI18n()

    // refs/reactive data
    const postalCode = ref('')

    const inputValidate = () => {
      postalNumberValidate('postalCode', postalCode.value)
    }

    const { validateOnBlur } = useTabKeyValidation(inputValidate)

    const { postalNumberValidate, errorObj } = useSignup(t)

    const debouncedInputValidate = debounce(inputValidate, 500)

    return { postalCode, debouncedInputValidate, inputValidate, validateOnBlur, t, errorObj }
  }
}
</script>

<style lang="scss" scoped>
.input-wrapper {
  position: relative;
  &__input {
    @include input;

    &:focus {
        @include input-focus;
    }
  }
  &__label {
    text-align: left;

    @include input-label;

    &--error {
      @include error-message;
      &::after {
        content: '';
        width: var(--spacing-m);
        height: var(--spacing-m);
        position: absolute;
        top: 36px;
        right: 12px;
        background-image: url('../assets/images/exclamation-circle.svg');
        background-position: center center;
        background-repeat: no-repeat;
        z-index: -1;

        @include respond-to('small') {
          top: 40px;
        }
      }
    }
  }
  .invalid-input {
    @include invalid-input;
  }

  @include shake;
}
</style>
